import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des documents côté admin.
 *
 * @param string token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAdminEmailList = (token, currentPage, itemsPerPage) => {
    const url = `/api-v1/admin/email/${currentPage}/${itemsPerPage}/list`
    return getRequest(url, token)
}

/**
 * Récupération des infos d'un email côté admin.
 *
 * @param string token Jeton d'authentification.
 * @param string emailId Identifiant de l'email.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEmailInfos = (token, id) => {
    const url = `/api-v1/admin/email/${id}/infos`
    return getRequest(url, token)
}

/**
 * Modification des infos d'un email côté admin.
 *
 * @param string token Jeton d'authentification.
 * @param string emailId Identifiant de l'email.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateEmailInfos = (token, body) => {
    const url = `/api-v1/admin/email/update`
    return postRequest(url, body, token)
}

